<template>
  <div>
    <ReportBasic
      ref="BasicInfoRef"
      @goEntryManagementPage="goEntryManagementPage"
    />
    <vab-form ref="form" :model="form" :rules="rules" :disabled="!showBtn">
      <div class="mt16 rc_boxshadow shadow_boxpadding">
        <vab-filerc ref="vabFile">
          <div slot="h_title">報告書の提出を行ってください</div>
        </vab-filerc>
      </div>
      <div v-if="isEquipment">
        <div
          v-for="(item, index) in form.reportDetailRcModelList"
          :key="index"
          class="mt24 rc_boxshadow shadow_boxpadding"
        >
          <div
            v-if="
              item.operationType != $divisions.operationTypeEnum.enum_D.value
            "
          >
            <div
              style="cursor: pointer"
              class="head_box flex_start flex_center_align"
              @click="isShow(item, index)"
            >
              <img src="~@/assets/images/r2.png" alt="" />
              <span class="hd_title">
                <slot name="hd_title">作業報告{{ item.workNo }}</slot>
              </span>
              <div class="pos_end">
                <div class="arrow_box flex_center_align flex_center">
                  <svg-icon
                    icon-class="up_line"
                    class="arrow_svg"
                    :class="{ rote: item.workFold }"
                  />
                </div>
              </div>
            </div>
            <div v-show="item.workFold" class="scd_cnt_box">
              <div class="row_out_box mt12">
                <vab-row class="row_box">
                  <vab-col :span="4" class="title_box bdt0">
                    作業No
                    <i class="red">*</i>
                  </vab-col>
                  <vab-col :span="20" class="word_box word_col_input bdt0">
                    <vab-select
                      label-width="0"
                      class="width160"
                      :prop="`reportDetailRcModelList.${index}.workNo`"
                      :data-items="workNoList"
                      validate="required"
                      label-id="workNo"
                      value-id="workNo"
                      placeholder=""
                      clearable
                      collapse-tags
                      label-error="作業No"
                    />
                  </vab-col>
                </vab-row>
                <vab-row class="row_box">
                  <vab-col :span="4" class="title_box">
                    棟
                    <i class="red">*</i>
                  </vab-col>
                  <vab-col :span="20" class="word_box word_col_input">
                    <div class="build_section">
                      <div class="build_section_item">
                        <vab-select
                          class="wid80"
                          label-width="0"
                          :prop="`reportDetailRcModelList.${index}.reportSectionCd`"
                          :data-items="mbuildList"
                          validate="required"
                          label-id="bldgcd"
                          value-id="bldgcd"
                          clearable
                          collapse-tags
                          placeholder=""
                          label-error="棟"
                          @change="handlemBuildListChange(item, index)"
                        />
                      </div>
                      <div class="build_section_item">
                        {{ item.blgsnmkj }}
                      </div>
                    </div>
                  </vab-col>
                </vab-row>
                <vab-row class="row_box">
                  <vab-col :span="4" class="title_box">前回作業No</vab-col>
                  <vab-col :span="20" class="word_box">
                    {{ getFieldValue('lastReportDetailRc.workNo', item) }}
                  </vab-col>
                </vab-row>
              </div>
              <div
                v-for="(son, sonIndex) in item.equipmentInspectionModelList"
                :key="sonIndex"
              >
                <div class="row_out_box mt12">
                  <vab-row class="row_box">
                    <vab-col
                      :span="24"
                      class="word_box word_col_title bdt0 bdr0"
                    >
                      <span class="low_box">
                        総合設備点検結果{{ sonIndex + 1 }}
                      </span>
                    </vab-col>
                    <vab-col :span="4" class="title_box">
                      対応状況
                      <i class="red">*</i>
                    </vab-col>
                    <vab-col :span="20" class="word_box nopadding2 word_flex">
                      <vab-radio-group
                        :ref="`workReportRef${index}`"
                        label=""
                        label-width="0"
                        :prop="`reportDetailRcModelList.${index}.responseStatus`"
                        filter="responseStatus"
                        validate="required"
                        :code-enum="$divisions.dealingFlgEnum"
                      />
                      <span
                        v-if="!item.reportDetailId"
                        class="delete"
                        @click="deleteEquipmentResultList(index, son)"
                      >
                        削除
                      </span>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box flex_col bg">
                      <div class="flex_col_title">報告内容</div>
                      <span
                        :class="[
                          defectiveNoClass(son)
                            ? 'fault_no_btn'
                            : 'fault_no_btn_disabled fault_no_btn',
                          !showBtn ? 'fault_no_btn_disabled fault_no_btn' : '',
                        ]"
                        @click="failureNoDialog(son, index, sonIndex)"
                      >
                        不具合No
                      </span>
                    </vab-col>
                    <vab-col :span="8" class="word_box word_col_input">
                      <div class="mb8 line15">
                        不具合No：
                        {{ defectNoFormat(son.defectiveNo) }}
                      </div>
                      <div class="line15 pre_wrap">
                        {{ son.reportContent }}
                      </div>
                    </vab-col>
                    <vab-col :span="4" class="word_box title_box">
                      報告内容（前回）
                    </vab-col>
                    <vab-col :span="8" class="word_box word_col_input line15">
                      <div class="mb8 line15">
                        不具合No：
                        {{
                          defectNoFormat(
                            getFieldValue(
                              `lastReportDetailRc.equipmentInspectionModelList[${sonIndex}].defectiveNo`,
                              item
                            )
                          )
                        }}
                      </div>
                      <div class="line15 pre_wrap">
                        {{
                          getFieldValue(
                            `lastReportDetailRc.equipmentInspectionModelList[${sonIndex}].reportContent`,
                            item
                          )
                        }}
                      </div>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">
                      点検リスト分類
                    </vab-col>
                    <vab-col :span="20" class="word_box word_col_input">
                      <div class="flex_select_box">
                        <div class="select_box_item">
                          <vab-select
                            label="分類1"
                            label-width="50px"
                            :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.inspectionList1Cd`"
                            class="flex_select1"
                            :data-items="son.inspectionList1CdList"
                            label-id="inlstbr1cd"
                            value-id="inlstbr1cd"
                            :disabled="!$baseLodash.trim(item.reportSectionCd)"
                            placeholder=""
                            collapse-tags
                            @change="inspectionList1CdChange(son, item)"
                          />
                        </div>
                        <div
                          v-if="son.inspectionList1Cd"
                          class="select_box_icon"
                        >
                          <svg-icon
                            icon-class="right_line"
                            class="arrow_svg_right"
                          />
                        </div>
                        <div
                          v-if="son.inspectionList1Cd"
                          class="select_box_item"
                        >
                          <vab-select
                            label="分類2"
                            label-width="50px"
                            :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.inspectionList2Cd`"
                            class="flex_select1"
                            :data-items="son.inspectionList2CdList"
                            label-id="inlstbr2cd"
                            value-id="inlstbr2cd"
                            placeholder=""
                            collapse-tags
                            @change="inspectionList2CdChange(son, item)"
                          />
                        </div>
                        <div
                          v-if="son.inspectionList2Cd"
                          class="select_box_icon"
                        >
                          <svg-icon
                            icon-class="right_line"
                            class="arrow_svg_right"
                          />
                        </div>
                        <div
                          v-if="son.inspectionList2Cd"
                          class="select_box_item"
                        >
                          <vab-select
                            label="分類3"
                            label-width="50px"
                            :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.inspectionList3Cd`"
                            class="flex_select1"
                            :data-items="son.inspectionList3CdList"
                            label-id="inlstbr3cd"
                            value-id="inlstbr3cd"
                            placeholder=""
                            collapse-tags
                            @change="inspectionList3CdChange(son, item)"
                          />
                        </div>
                      </div>
                      <div class="normal_words mt8">
                        分類名：
                        <span v-if="son.br1nm">
                          {{ son.br1nm }}
                        </span>
                        <span v-if="son.br2nm">
                          <svg-icon
                            icon-class="right_line"
                            class="arrow_svg_right"
                          />
                        </span>
                        <span v-if="son.br2nm">
                          {{ son.br2nm }}
                        </span>
                        <span v-if="son.br3nm">
                          <svg-icon
                            icon-class="right_line"
                            class="arrow_svg_right"
                          />
                        </span>
                        <span v-if="son.br3nm">
                          {{ son.br3nm }}
                        </span>
                      </div>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">
                      点検番号
                    </vab-col>
                    <vab-col :span="20" class="word_box word_col_input">
                      <vab-input
                        v-input.num_alp
                        maxlength="4"
                        :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.inspectionItemsNo`"
                        class="flex_input1"
                      />
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">
                      該当箇所
                    </vab-col>
                    <vab-col :span="20" class="word_box word_col_input">
                      <div class="flex_input">
                        <vab-input
                          v-input.num
                          maxlength="3"
                          :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.machineNo`"
                          class="flex_input1"
                          @blur="blurNoInput(item)"
                        />
                        <span class="input_unit">号機</span>
                        <vab-input
                          label="部位"
                          maxlength="40"
                          class="flex_input2"
                          label-width="40px"
                          :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.position`"
                        />
                      </div>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">数値</vab-col>
                    <vab-col :span="8" class="word_box word_col_input">
                      <div class="flex_input">
                        <vab-input
                          v-input.float="2"
                          v-numberFormat.float="2"
                          :prop="`reportDetailRcModelList.${index}.equipmentInspectionModelList.${sonIndex}.meterValue`"
                          class="flex_input1 flex_input_num"
                          validate="range:0|99999.99"
                        />
                      </div>
                    </vab-col>
                    <vab-col :span="4" class="word_box title_box">
                      数値（前回）
                    </vab-col>
                    <vab-col :span="8" class="word_box line15">
                      {{
                        formatNumber(
                          getFieldValue(
                            `lastReportDetailRc.equipmentInspectionModelList[${sonIndex}].meterValue`,
                            item
                          ),
                          '0,0.00'
                        )
                      }}
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">
                      経過年数
                    </vab-col>
                    <vab-col :span="8" class="word_box line15">
                      <template v-if="son.usestrym">
                        {{ son.usestrym }}
                      </template>
                    </vab-col>
                    <vab-col :span="4" class="word_box title_box">
                      耐用年数
                    </vab-col>
                    <vab-col :span="8" class="word_box line15">
                      <template v-if="son.taiyy && son.taiym">
                        {{ son.taiyy }}年{{ son.taiym }}ヶ月
                      </template>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">写真</vab-col>
                    <vab-col
                      :span="20"
                      class="word_box word_col_input word_col_upload"
                    >
                      <div class="word_bgF7">
                        <vab-upload
                          v-if="showBtn"
                          :ref="`equipmentRef${index}${sonIndex}`"
                          :upload-url="`/api/defectPhoto/uploadFile`"
                          :params-data="{
                            equipmentInspectionId: son.equipmentInspectionId,
                            reportNo: reportNo,
                            reportId: reportId,
                            buildingCd: currentBascInfo.buildingCd,
                          }"
                          :action-item="{ item, index, sonIndex }"
                          :init-before="false"
                          :su-ts="false"
                          @on-success="
                            (res) => successPhotoFile(res, index, sonIndex)
                          "
                        />
                        <div
                          v-if="
                            son.defectPhotoModelList &&
                            changeFileList(son.defectPhotoModelList).length
                          "
                          class="word_col_upload_filebox"
                        >
                          <div
                            v-for="(file, f) in son.defectPhotoModelList"
                            :key="f"
                            :class="[
                              file.operationType !=
                              $divisions.operationTypeEnum.enum_D.value
                                ? 'file_inner_item flex_start'
                                : '',
                            ]"
                          >
                            <template
                              v-if="
                                file.operationType !=
                                $divisions.operationTypeEnum.enum_D.value
                              "
                            >
                              <svg-icon
                                icon-class="tryangle_right"
                                class="arrow"
                              />
                              <div class="file_name_out_box">
                                <div class="flex_colum file_name_box">
                                  <span
                                    class="file_name"
                                    @click="defectPhotoDownLoad(son, file)"
                                  >
                                    {{ file.photoName }}
                                  </span>
                                  <div class="file_time">
                                    アップロード日時：{{ file.createDate }}
                                    {{ file.createTime.substring(0, 8) }}
                                  </div>
                                  <svg-icon
                                    v-if="showBtn && delSvgShow"
                                    icon-class="close_circle_fill"
                                    class="del"
                                    @click="
                                      handleEqumentDefectPhotoDelete(
                                        file,
                                        item,
                                        index,
                                        sonIndex,
                                        f
                                      )
                                    "
                                  />
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </vab-col>
                  </vab-row>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showBtn" class="row_btm_btn">
          <span class="defect_addition mt12" @click="addWorkNoReportList">
            <svg-icon icon-class="add" />
            作業報告を追加
          </span>
        </div>
      </div>
      <div v-else>
        <div
          v-for="(item, index) in form.reportDetailRcModelList"
          :key="index"
          class="mt16 rc_boxshadow shadow_boxpadding"
        >
          <div
            style="cursor: pointer"
            class="head_box flex_start flex_center_align"
            @click="isShow(item, index)"
          >
            <img src="~@/assets/images/r2.png" alt="" />
            <span class="hd_title">
              <slot name="hd_title">作業報告{{ item.workNo }}</slot>
            </span>
            <div class="pos_end pointer">
              <div class="arrow_box flex_center_align flex_center">
                <svg-icon
                  icon-class="up_line"
                  class="arrow_svg"
                  :class="{ rote: item.workFold }"
                />
              </div>
            </div>
          </div>
          <div v-show="item.workFold" class="scd_cnt_box mt12">
            <div class="row_out_box">
              <vab-row class="row_box">
                <vab-col :span="4" class="title_box bdt0">
                  作業No
                  <i class="red">*</i>
                </vab-col>
                <vab-col
                  :span="20"
                  class="word_box word_col_input bdt0 flex_space flex_center_align"
                >
                  <vab-select
                    label-width="0"
                    class="width160"
                    :prop="`reportDetailRcModelList.${index}.workNo`"
                    :data-items="workNoList"
                    validate="required"
                    label-id="workNo"
                    value-id="workNo"
                    placeholder=""
                    clearable
                    collapse-tags
                  />
                  <span
                    v-if="!item.reportDetailId"
                    class="delete_report_deatail"
                    @click="deleteReportDetailRc(item, index)"
                  >
                    削除
                  </span>
                </vab-col>
              </vab-row>
              <vab-row class="row_box">
                <vab-col :span="4" class="title_box">
                  棟
                  <i class="red">*</i>
                </vab-col>
                <vab-col :span="20" class="word_box word_col_input">
                  <div class="build_section">
                    <div class="build_section_item">
                      <vab-select
                        class="wid80"
                        label-width="0"
                        :prop="`reportDetailRcModelList.${index}.reportSectionCd`"
                        :data-items="mbuildList"
                        label-id="bldgcd"
                        validate="required"
                        value-id="bldgcd"
                        clearable
                        collapse-tags
                        placeholder=""
                        @change="handlemBuildListChange(item, index)"
                      />
                    </div>
                    <div class="build_section_item">
                      {{ item.blgsnmkj }}
                    </div>
                  </div>
                </vab-col>
              </vab-row>
              <vab-row class="row_box">
                <vab-col :span="4" class="title_box">
                  対応状況
                  <i class="red">*</i>
                </vab-col>
                <vab-col
                  :span="20"
                  class="word_box nopadding2 flex_center_align"
                >
                  <vab-radio-group
                    :ref="`workReportRef${index}`"
                    :prop="`reportDetailRcModelList.${index}.responseStatus`"
                    validate="required"
                    filter="responseStatus"
                    @change="responseStatusFilter(item, index)"
                  />
                </vab-col>
              </vab-row>
              <vab-row
                v-if="
                  !isEqualCodeEnum(
                    item.responseStatus,
                    $divisions.responseStatusEnum.enum_3
                  )
                "
                class="row_box"
              >
                <vab-col :span="4" class="word_box title_box" />
                <vab-col :span="10" class="word_box word_col_title">
                  <span class="low_box">今回</span>
                </vab-col>
                <vab-col :span="10" class="word_box word_col_title">
                  <span class="low_box">前回</span>
                </vab-col>
              </vab-row>
              <vab-row
                v-if="
                  !isEqualCodeEnum(
                    item.responseStatus,
                    $divisions.responseStatusEnum.enum_3
                  )
                "
                class="row_box"
              >
                <vab-col :span="4" class="word_box title_box">報告内容</vab-col>
                <vab-col :span="10" class="word_box word_col_input">
                  <vab-textarea
                    class="height100"
                    :prop="`reportDetailRcModelList.${index}.reportContent`"
                    maxlength="1170"
                  />
                </vab-col>
                <vab-col :span="10" class="word_box word_col_cont">
                  {{ getFieldValue('lastReportDetailRc.reportContent', item) }}
                </vab-col>
              </vab-row>
              <vab-row
                v-if="
                  !isEqualCodeEnum(
                    item.responseStatus,
                    $divisions.responseStatusEnum.enum_3
                  ) &&
                  isEqualCodeEnum(
                    adjSourceClass,
                    $divisions.adjSourceClassEnum.enum_2
                  )
                "
                class="row_box"
              >
                <vab-col :span="4" class="word_box title_box">対処内容</vab-col>
                <vab-col
                  :span="10"
                  class="word_box word_col_input heightNormal"
                >
                  <vab-textarea
                    :prop="`reportDetailRcModelList.${index}.reportDealContent`"
                    maxlength="1170"
                  />
                </vab-col>
                <vab-col :span="10" class="word_box word_col_input">
                  {{
                    getFieldValue('lastReportDetailRc.reportDealContent', item)
                  }}
                </vab-col>
              </vab-row>
              <vab-row
                v-if="
                  !isEqualCodeEnum(
                    item.responseStatus,
                    $divisions.responseStatusEnum.enum_3
                  ) &&
                  isEqualCodeEnum(
                    adjSourceClass,
                    $divisions.adjSourceClassEnum.enum_2
                  )
                "
                class="row_box"
              >
                <vab-col :span="4" class="word_box title_box">
                  報告コメント
                </vab-col>
                <vab-col
                  :span="10"
                  class="word_box word_col_input heightNormal"
                >
                  <vab-textarea
                    :prop="`reportDetailRcModelList.${index}.reportComment`"
                    maxlength="1170"
                  />
                </vab-col>
                <vab-col :span="10" class="word_box word_col_input">
                  {{ getFieldValue('lastReportDetailRc.reportComment', item) }}
                </vab-col>
              </vab-row>
            </div>
          </div>
        </div>
        <div v-if="showBtn" class="row_btm_btn">
          <span class="defect_addition mt12" @click="addWorkNoReportList">
            <svg-icon icon-class="add" />
            作業報告を追加
          </span>
        </div>
        <div class="mt16 rc_boxshadow shadow_boxpadding">
          <div
            style="cursor: pointer"
            class="head_box flex_start flex_center_align"
            @click="defectFold = !defectFold"
          >
            <img src="~@/assets/images/r2.png" alt="" />
            <span class="hd_title">
              <slot name="hd_title">不具合情報</slot>
            </span>
            <div class="pos_end">
              <div class="arrow_box flex_center_align flex_center">
                <svg-icon
                  icon-class="up_line"
                  class="arrow_svg"
                  :class="{ rote: defectFold }"
                />
              </div>
            </div>
          </div>
          <div v-show="defectFold">
            <div
              v-for="(item, index) in form.defectReportModelList"
              :key="index"
              class="scd_cnt_box"
            >
              <div
                v-if="
                  item.operationType !=
                  $divisions.operationTypeEnum.enum_D.value
                "
              >
                <div class="scd_title">
                  <i></i>
                  不具合情報ID：{{ item.defectReportId }}
                </div>
                <div class="row_out_box mb12">
                  <vab-row class="row_box">
                    <vab-col :span="4" class="title_box bdt0">
                      場所
                      <i class="red">*</i>
                    </vab-col>
                    <vab-col
                      :span="20"
                      class="word_box nopadding2 word_flex bdt0"
                    >
                      <vab-input
                        :validate="requireditem(item)"
                        :prop="`defectReportModelList.${index}.defectIdModel.location`"
                        :disabled="
                          !isEqualCodeEnum(
                            item.inspectionStatus,
                            $divisions.inspectionStatusEnum.enum_3
                          ) || $baseLodash.isNumber(item.defectId)
                        "
                        class="unset"
                        label-error="不具合情報場所"
                        maxlength="150"
                      />
                      <span
                        v-if="
                          isEqualCodeEnum(
                            item.inspectionStatus,
                            $divisions.inspectionStatusEnum.enum_3
                          ) && !item.defectId
                        "
                        class="delete"
                        @click="deleteDefectReportList(item, index)"
                      >
                        削除
                      </span>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">
                      不具合内容
                      <i class="red">*</i>
                    </vab-col>
                    <vab-col :span="20" class="word_box word_col_input">
                      <vab-textarea
                        :prop="`defectReportModelList.${index}.defectIdModel.defectContent`"
                        :validate="requireditem(item)"
                        :disabled="
                          !isEqualCodeEnum(
                            item.inspectionStatus,
                            $divisions.inspectionStatusEnum.enum_3
                          ) || $baseLodash.isNumber(item.defectId)
                        "
                        label-error="不具合内容"
                        class="height100 unset"
                        maxlength="2340"
                      />
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="word_box title_box">写真</vab-col>
                    <vab-col
                      :span="20"
                      class="word_box word_col_input word_col_upload"
                    >
                      <div class="word_bgF7">
                        <vab-upload
                          :ref="`defectUploadRef${index}`"
                          :upload-url="`/api/defectPhoto/uploadFile`"
                          :params-data="{
                            defectIdPlus: item.defectId,
                            reportNo: reportNo,
                            buildingCd: item.buildingCd,
                          }"
                          :action-item="{ item, index }"
                          :init-before="false"
                          :su-ts="false"
                          :disabled="uploadDisabled(item)"
                          @on-success="(res) => successPhotoFile(res, index)"
                          @getUploadData="getDefectIdBeforeUpload(item, index)"
                        />

                        <div
                          v-if="changePhontFileList(item).length > 0"
                          class="word_col_upload_filebox"
                        >
                          <div
                            v-for="(file, f) in getFieldValue(
                              'defectIdModel.defectPhotoModelList',
                              item
                            )"
                            :key="f"
                            :class="[
                              file.operationType !=
                              $divisions.operationTypeEnum.enum_D.value
                                ? 'file_inner_item flex_start'
                                : '',
                            ]"
                          >
                            <template
                              v-if="
                                file.operationType !=
                                $divisions.operationTypeEnum.enum_D.value
                              "
                            >
                              <svg-icon
                                icon-class="tryangle_right"
                                class="arrow"
                              />
                              <div class="file_name_out_box">
                                <div class="flex_colum file_name_box">
                                  <span
                                    class="file_name"
                                    @click="defectPhotoDownLoad(item, file)"
                                  >
                                    {{ file.photoName }}
                                  </span>
                                  <div class="file_time">
                                    アップロード日時：{{
                                      file.createDate
                                    }}&nbsp;
                                    {{
                                      file.createTime &&
                                      file.createTime.substring(0, 8)
                                    }}
                                  </div>
                                  <svg-icon
                                    v-if="showBtn && delSvgShow"
                                    icon-class="close_circle_fill"
                                    class="del"
                                    @click="
                                      handleDefectPhotoDelete(file, item, f)
                                    "
                                  />
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="title_box">
                      点検結果
                      <i class="red">*</i>
                    </vab-col>
                    <vab-col
                      :span="20"
                      class="word_box nopadding2 flex_center_align noa1"
                    >
                      <vab-radio-group
                        :ref="`defectRadioRef${index}`"
                        label=""
                        label-width="0"
                        validate="required"
                        :prop="`defectReportModelList.${index}.inspectionStatus`"
                        filter="inspectionStatus"
                        :code-enum="$divisions.inspectionStatusEnum"
                        :disabled="!item.defectId"
                      />
                    </vab-col>
                  </vab-row>
                  <vab-row class="row_box">
                    <vab-col :span="4" class="title_box">初回報告日</vab-col>
                    <vab-col :span="20" class="word_box">
                      {{ getFieldValue('defectIdModel.firstReportDate', item) }}
                      <span
                        v-if="
                          getFieldValue('defectIdModel.firstReportDate', item)
                        "
                        class="without_experience"
                        @click="withoutExperienceDialog(item.defectId)"
                      >
                        <svg-icon icon-class="select" />
                        不具合履歴
                      </span>
                    </vab-col>
                  </vab-row>
                </div>
              </div>
            </div>
            <span
              v-if="showBtn"
              class="defect_addition mt12"
              :class="changeDefaultList.length ? '' : 'mt12'"
              @click="addDefectReportList"
            >
              <svg-icon icon-class="add" />
              不具合追加
            </span>
          </div>
        </div>
        <div
          v-if="
            itemDetailCd == '001' ||
            itemDetailCd == '400' ||
            itemDetailCd == '007'
          "
          class="mt16 rc_boxshadow shadow_boxpadding"
        >
          <div
            style="cursor: pointer"
            class="head_box flex_start flex_center_align"
            @click="unimplementFold = !unimplementFold"
          >
            <img src="~@/assets/images/r2.png" alt="" />
            <span class="hd_title">
              <slot name="hd_title">作業未実施住戸情報</slot>
            </span>
            <div class="pos_end">
              <div class="arrow_box flex_center_align flex_center">
                <svg-icon
                  icon-class="up_line"
                  class="arrow_svg"
                  :class="{ rote: unimplementFold }"
                />
              </div>
            </div>
          </div>
          <div v-show="unimplementFold">
            <div
              v-for="(item, index) in form.workImplementInfoModelList"
              :key="index"
              class="scd_cnt_box"
            >
              <div class="scd_title1 flex_center_align">
                <i></i>
                棟{{ item.reportSectionCd }}：{{ item.blgsnmkj }}
                <vab-checkbox
                  :ref="`allFlagRef${index}`"
                  class="ml12I"
                  :prop="`workImplementInfoModelList.${index}.allImplementClass`"
                  :code-enum="$divisions.boolFlagEnum"
                  label="全戸実施"
                  @change="isAllWorkImplementChange(item, index)"
                />
              </div>
              <template
                v-if="
                  !isEqualCodeEnum(
                    item.allImplementClass,
                    $divisions.boolFlagEnum.enum_1
                  )
                "
              >
                <div class="h_date">
                  <span class="h_title">
                    <slot name="h_title">未実施住戸登録を行ってください</slot>
                  </span>
                </div>
                <div class="row_out_box mb8">
                  <vab-row class="row_box">
                    <vab-col :span="4" class="title_box bdt0">区画</vab-col>
                    <vab-col :span="4" class="title_box bdt0">
                      未実施区分
                    </vab-col>
                    <vab-col :span="16" class="title_box bdt0">
                      コメント
                    </vab-col>
                  </vab-row>
                  <vab-row
                    v-for="(son, sonIndex) in item.workUnimplementInfoModelList"
                    :key="sonIndex"
                    class="row_box"
                  >
                    <vab-col :span="4" class="word_box word_col_input">
                      <!-- :validate="son.unimplementClass ? 'required' : ''" -->
                      <vab-select
                        :prop="`workImplementInfoModelList.${index}.workUnimplementInfoModelList.${sonIndex}.roomNo`"
                        :data-items="
                          roomList(
                            item.workUnimplementInfoModelList,
                            item.roomList
                          )
                        "
                        value-id="roomno"
                        clearable
                        collapse-tags
                        @change="handleWorkUnimplementChange(son, index)"
                      />
                    </vab-col>
                    <vab-col :span="4" class="word_box word_col_input">
                      <!-- :validate="son.roomNo ? 'required' : ''" -->
                      <vab-select
                        :ref="`unimplementClass${index}Ref${sonIndex}`"
                        :prop="`workImplementInfoModelList.${index}.workUnimplementInfoModelList.${sonIndex}.unimplementClass`"
                        filter="unimplementNewClass"
                        clearable
                        collapse-tags
                        @change="handleWorkUnimplementChange(son, index)"
                      />
                    </vab-col>
                    <vab-col :span="16" class="word_box word_col_input">
                      <vab-input
                        maxlength="200"
                        :prop="`workImplementInfoModelList.${index}.workUnimplementInfoModelList.${sonIndex}.comment`"
                        @input="changeInput(son, index)"
                      />
                    </vab-col>
                  </vab-row>
                </div>
                <div v-if="showBtn" class="flex_count">
                  <span
                    class="defect_addition"
                    @click="addWorkUnimplementList(item, index)"
                  >
                    <svg-icon icon-class="select" />
                    追加
                  </span>
                </div>
              </template>

              <ul
                v-if="index == form.workImplementInfoModelList.length - 1"
                class="count_ul"
              >
                <li>
                  <span class="count_li_name">全戸数</span>
                  <span class="count_li_count">
                    {{ form.inspectionTargetRoomNum }}
                  </span>
                </li>
                <li>
                  <span class="count_li_name">未実施戸数</span>
                  <span class="count_li_count">
                    {{ form.uncheckRoomNum ? form.uncheckRoomNum : 0 }}
                  </span>
                </li>
                <li>
                  <span class="count_li_name">実施率</span>
                  <span class="count_li_count">{{ form.checkRate }}％</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--  コメント-->
      <div class="mt16 rc_boxshadow shadow_boxpadding">
        <div class="head_box flex_start flex_center_align">
          <img src="~@/assets/images/r2.png" alt="" />
          <span class="hd_title">
            <slot name="hd_title">コメント</slot>
          </span>
        </div>
        <div class="row_out_box mb12 mt12">
          <div v-for="(item, index) in comList" :key="index">
            <vab-row
              v-if="
                item.type == 'pre' &&
                isEqualCodeEnum(
                  reportFormat,
                  $divisions.reportFormatEnum.enum_1
                )
              "
              class="row_box"
            >
              <vab-col :span="4" class="title_box bdt0">速報版</vab-col>
              <vab-col :span="20" class="col_content word_box bdt0">
                <div class="col_content_box">
                  <div class="col_content_title">提出日</div>
                  <div v-if="item.picker" class="col_content_cont">
                    <vab-date-picker
                      type="date"
                      style="width: 140px"
                      value-format="yyyy/MM/dd"
                      :disabled="item.disabled"
                      format="yyyy/MM/dd"
                      prop="prePartenrSubmitDate"
                    />
                  </div>
                  <div v-else>
                    {{ item.prePartenrSubmitDate }}
                  </div>
                </div>
                <div class="col_content_box">
                  <div class="col_content_title">結果</div>
                  <div class="col_content_cont">
                    {{ item.statusName }}
                  </div>
                </div>
              </vab-col>
            </vab-row>
            <vab-row v-if="item.type == 'off'" class="row_box">
              <vab-col :span="4" class="title_box">正式版</vab-col>
              <vab-col :span="20" class="col_content word_box">
                <div>
                  <div class="col_content_box">
                    <div class="col_content_title">提出方法</div>
                    <div class="col_content_cont">
                      <vab-radio-group
                        v-if="item.picker || item.raido"
                        ref="legalPostsendFlgRef"
                        label-width="0"
                        :disabled="item.disabled"
                        prop="legalPostsendFlg"
                        :data-items="$const.legalPostsendFlg"
                        label-id="text"
                        value-id="value"
                      />
                      <div v-else>
                        {{ item.legalPostsendFlg }}
                      </div>
                    </div>
                  </div>
                  <div class="col_content_box">
                    <div class="col_content_title">提出日</div>
                    <div class="col_content_cont">
                      <vab-date-picker
                        v-if="item.picker"
                        type="date"
                        style="width: 140px"
                        :disabled="item.disabled"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        prop="officalPartenrSubmitDate"
                      />
                      <div v-else>
                        {{ item.officalPartenrSubmitDate }}
                      </div>
                    </div>
                  </div>
                  <div class="col_content_box">
                    <div class="col_content_title">結果</div>
                    <div class="col_content_cont">
                      {{ item.statusName }}
                    </div>
                  </div>
                </div>
              </vab-col>
            </vab-row>
          </div>
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">法定報告書提出日</vab-col>
            <vab-col :span="8" class="col_content word_box word_col_input">
              <vab-date-picker
                type="date"
                :label-show="false"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                prop="legalSubmitDate"
                style="width: 50%"
                :disabled="
                  !isEqualCodeEnum(
                    reportBaseInfo.officalReportStatus,
                    $divisions.reportStatusEnum.enum_11
                  )
                "
              />
            </vab-col>
            <vab-col :span="4" class="title_box">副本受領日</vab-col>
            <vab-col :span="8" class="col_content word_box word_col_input bdr0">
              {{ reportBaseInfo.duplicateConfrimDate }}
            </vab-col>
            <template v-if="btnData.show">
              <vab-col :span="4" class="word_box title_box">特記事項</vab-col>
              <vab-col :span="20" class="word_box word_col_input">
                <!-- 速報版 -->
                <vab-textarea
                  v-if="
                    isEqualCodeEnum(
                      reportFormat,
                      $divisions.reportFormatEnum.enum_1
                    ) &&
                    !isEqualCodeEnum(
                      reportBaseInfo.preReportStatus,
                      $divisions.reportStatusEnum.enum_05
                    )
                  "
                  maxlength="1000"
                  prop="prePartenrComment"
                  class="height100"
                />
                <!-- 正式版 -->
                <vab-textarea
                  v-if="
                    isEqualCodeEnum(
                      reportFormat,
                      $divisions.reportFormatEnum.enum_2
                    ) ||
                    isEqualCodeEnum(
                      reportBaseInfo.preReportStatus,
                      $divisions.reportStatusEnum.enum_05
                    )
                  "
                  maxlength="1000"
                  prop="officalPartenrComment"
                  class="height100"
                />
              </vab-col>
            </template>
          </vab-row>
        </div>
        <vab-messagerc
          ref="vabMessage"
          class="noborder"
          :title="'コメント履歴を閉じる'"
        />
      </div>
    </vab-form>
    <ErrorSelect
      ref="failureNo"
      :visible.sync="novisable"
      @handledefectNoChoose="handledefectNoChose"
    />
    <ErrorRecords ref="errorRecords" />
    <div class="flex_space">
      <div class="mg12 zh_btn_box flex_start flex_center_align">
        <vab-button :btn-list="btnLeft" />
      </div>
      <div class="flex_start zh_btn_box mg12">
        <vab-button :btn-list="btnRight" />
      </div>
    </div>
  </div>
</template>

<script>
  import ErrorRecords from '@/biz/components/condition/error-records.vue'
  import mixins from '@/utils/mixinPage'
  import mixReport from '@/utils/mixReport'
  import {
    getComprehensiveClassification1,
    getComprehensiveClassification2,
    getComprehensiveClassification3,
    getCreateDate,
    getBuildingPartition,
    getworkImplementInfoList,
    getDefectReport,
    getReportDetails,
    insOrUpd,
    // getDefectReportFile,
    defectPhotoDelete,
    // getEquipmentInspectionFile1,
    mprbnoFoundData,
  } from '@/api/rc/PWR02G06'

  export default {
    name: 'DWR03G03',
    components: {
      ErrorRecords,
    },
    mixins: [mixins, mixReport],
    data() {
      return {
        allImplementClass: this.$divisions.boolFlagEnum.enum_blank.value,
        novisable: false,
        form: {
          inspectionTargetRoomNum: 0,
          workImplementInfoModelList: [],
          reportDetailRcModelList: [],
          defectReportModelList: [],
          workNoList: [],
          uncheckRoomNum: 0,
          checkRate: null,
          preReportStatus: null,
          officalReportStatus: null,
          prePsConfrimDate: null,
          preManageConfrimDate: null,
          officalPsConfrimDate: null,
          officalManageConfrimDate: null,
          officalLcConfrimDate: null,
        },

        rules: {},
        btnLeft: [
          {
            name: '点検総括表',
            icon: 'excel',
            type: 'plain',
            hover: '#0071EE',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000446.name}`
            ),
            widht: 'auto',
            defaultColor: '#0060C2',
            click: () => {
              this.excelDown()
            },
          },
        ],
        btnRight: [
          {
            name: '更新',
            icon: 'answer',
            msg: this.$t(`validateMessage.${this.$messageCode.I00000291.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000411.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.$refs['form'].validate((valid, obj) => {
                if (valid) {
                  this.submitForm(row)
                } else {
                  var a = []
                  for (let key in obj) {
                    a.push(obj[key][0].message)
                  }
                  this.$message({
                    message: a[0],
                    type: 'error',
                  })
                  return false
                }
              })
            },
          },
        ],
      }
    },
    computed: {
      roomList() {
        return (partentList, list) => {
          let roomNoList = partentList
            .filter((item) => item.roomNo)
            .map((item) => item.roomNo)
          let oldList = []
          list.map((room) => {
            if (roomNoList.includes(room.roomno)) {
              room.disabled = true
            } else {
              room.disabled = false
            }
            oldList.push(room)
          })
          return oldList
        }
      },
      requireditem() {
        return (item) => {
          if (
            !this.isEqualCodeEnum(
              item.inspectionStatus,
              this.$divisions.inspectionStatusEnum.enum_3
            ) ||
            this.$baseLodash.isNumber(item.defectId)
          ) {
            return ''
          } else {
            return 'required'
          }
        }
      },
      changePhontFileList() {
        return (item) => {
          return item?.defectIdModel?.defectPhotoModelList.filter(
            (item) =>
              item.operationType !=
              this.$divisions.operationTypeEnum.enum_D.value
          )
        }
      },
      defectiveNoClass() {
        return (item) => {
          return (
            item.inspectionList1Cd &&
            item.inspectionList2Cd &&
            item.inspectionList3Cd
          )
        }
      },
      changeFileList() {
        return (list) => {
          return list.filter(
            (item) =>
              item.operationType !=
              this.$divisions.operationTypeEnum.enum_D.value
          )
        }
      },
      changerWquipmentList() {
        return (list) => {
          return list.filter(
            (item) =>
              item.operationType !=
              this.$divisions.operationTypeEnum.enum_D.value
          )
        }
      },
      changeDefaultList() {
        return this.form.defectReportModelList.filter(
          (item) =>
            item.operationType != this.$divisions.operationTypeEnum.enum_D.value
        )
      },
    },
    created() {
      this.initData()
    },
    methods: {
      initData() {
        this.reportNo = this.$route?.query?.workNo
        this.itemDetailCd = this.$route?.query?.itemDetailCd
        this.reportId = this.$route?.query?.reportId ?? null
        this.workSpecCd = this.$route?.query?.workSpecCd
        // 総合設備点検
        if (this.itemDetailCd == '002') {
          this.isEquipment = true
          this.initEquipmentData()
        } else {
          this.isEquipment = false
          this.initNormalData()
        }
      },
      // 総合設備点検
      async initEquipmentData() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          // master
          await this.initMasterData()
          // 総設分類1
          await this.getInspectionList1CdList1()
          // 総設分類2
          await this.getInspectionList1CdList2()
          // 総設分類3
          await this.getInspectionList1CdList3()
          // 作業報告List
          await this.getReportDetailEquipmentList()
        } catch (error) {
          loadingInstance.close()
        }
        loadingInstance.close()
      },
      // 報告書提出
      async initNormalData() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          // master
          await this.initMasterData()
          // ＲＯＯＭ基本情報
          await this.getBuildingPartitions()
          // 作業報告List
          await this.getReportDetailList()
          // 不具合情報
          await this.getDefectReportsList()
          // 作業未実施住戸情報
          //"・商品明細が「400:雑排水管清掃」、「001:消防用設備点検」の場合、「建築設備定期検査（007）」、作業未実施住戸登録（変更・照会）画面へ遷移する。
          if (
            this.itemDetailCd == '001' ||
            this.itemDetailCd == '400' ||
            this.itemDetailCd == '007'
          ) {
            this.getWorkImplementLists()
          }
        } catch (error) {
          loadingInstance.close()
        }
        loadingInstance.close()
      },
      // 作業報告List
      async getReportDetailList() {
        let list = await getReportDetails(this.getReportRequestData())
        if (list && list.length == 0) {
          list =
            this.preBasicInfo?.reportNo &&
            (await getReportDetails({
              reportNo: this.preBasicInfo?.reportNo,
              currentReportNoFlg: false,
            }))
        }
        if (list?.length) {
          list.filter((item) => {
            item.workFold = true
            // 棟 blgsnmkj
            if (item?.reportSectionCd) {
              item.blgsnmkj = this.getSectionName(item.reportSectionCd)
            } else {
              item.blgsnmkj = null
            }
          })
          this.form.reportDetailRcModelList = this.$baseLodash.cloneDeep(list)
          this.clone.reportDetailRcModelList = this.$baseLodash.cloneDeep(
            list.filter((row) => row.reportDetailId)
          )
          this.$nextTick(() => {
            this.form.reportDetailRcModelList.filter((item, index) => {
              this.$refs['workReportRef' + index][0].setValue(
                item.responseStatus ??
                  this.$divisions.responseStatusEnum.enum_1.value
              )
            })
          })
        }
      },
      // 作業報告詳細総合設備点検List
      async getReportDetailEquipmentList() {
        let list = await getReportDetails(this.getReportRequestData())
        if (list && list.length == 0) {
          list =
            this.preBasicInfo?.reportNo &&
            (await getReportDetails({
              reportNo: this.preBasicInfo?.reportNo,
              currentReportNoFlg: false,
            }))
        }
        if (list?.length) {
          list.filter((item) => {
            item.workFold = true
          })
          let changeList = this.getChangeList(list)
          this.form.reportDetailRcModelList = changeList
          this.clone.reportDetailRcModelList = this.$baseLodash.cloneDeep(
            changeList.filter((row) => row.reportDetailId)
          )
          this.$nextTick(() => {
            this.form.reportDetailRcModelList.filter((item, index) => {
              if (this.$refs['workReportRef' + index]) {
                this.$refs['workReportRef' + index][0].setValue(
                  item.responseStatus
                )
              }
            })
          })
        }
      },
      // 組み立てデータです
      getChangeList(list) {
        list.filter(async (item) => {
          item.operationType = this.$divisions.operationTypeEnum.enum_U.value
          this.getCreateDate(item)
          if (item.lastReportDetailRc) {
            item.reportContent = null
          }
          // 棟 blgsnmkj
          if (item?.reportSectionCd) {
            item.blgsnmkj = this.getSectionName(item.reportSectionCd)
          } else {
            item.blgsnmkj = null
          }
          if (item.equipmentInspectionModelList.length == 0) {
            item.equipmentInspectionModelList.push(this.getEquipmentItem(item))
          } else {
            for (let i = 0; i < item.equipmentInspectionModelList.length; i++) {
              let row = item.equipmentInspectionModelList[i]
              if (!row?.defectPhotoModelList) {
                row.defectPhotoModelList = []
              }
              if (row?.equipmentInspectionId) {
                row.operationType =
                  this.$divisions.operationTypeEnum.enum_U.value
              } else {
                row.operationType =
                  this.$divisions.operationTypeEnum.enum_I.value
              }
              row.inspectionList1CdList = this.inspectionList1CdList
              row.inspectionList2CdList = this.inspectionList2CdList
              row.inspectionList3CdList = this.inspectionList3CdList

              if (row.inspectionList1Cd) {
                row.inspectionList2CdList = this.inspectionList2CdList.filter(
                  (son) => son.inlstbr1cd == row.inspectionList1Cd
                )

                let bsItem = this.inspectionList1CdList.find(
                  (box) => box.inlstbr1cd == row.inspectionList1Cd
                )
                if (!this.$baseLodash.isUndefined(bsItem)) {
                  row.br1nm = bsItem.br1nm
                }
              }
              if (row.inspectionList1Cd && row.inspectionList2Cd) {
                row.inspectionList3CdList = this.inspectionList3CdList.filter(
                  (son) =>
                    son.inlstbr1cd == row.inspectionList1Cd &&
                    son.inlstbr2cd == row.inspectionList2Cd
                )
              }

              if (row.inspectionList2Cd) {
                let bsItem = row.inspectionList2CdList.find(
                  (box) => box.inlstbr2cd == row.inspectionList2Cd
                )
                if (!this.$baseLodash.isUndefined(bsItem)) {
                  row.br2nm = bsItem.br2nm
                }
              }
              if (row.inspectionList3Cd) {
                let bsItem = row.inspectionList3CdList.find(
                  (box) => box.inlstbr3cd == row.inspectionList3Cd
                )
                if (!this.$baseLodash.isUndefined(bsItem)) {
                  row.br3nm = bsItem.br3nm
                }
              }

              if (
                !this.$baseLodash.isNull(row.inspectionList1Cd) &&
                !this.$baseLodash.isNull(row.inspectionList2Cd) &&
                !this.$baseLodash.isNull(row.inspectionList3Cd) &&
                !this.$baseLodash.isNull(row.defectiveNo)
              ) {
                // 総合設備点検不具合No
                let res = await mprbnoFoundData({
                  inlstbr1cd: row.inspectionList1Cd,
                  inlstbr2cd: row.inspectionList2Cd,
                  inlstbr3cd: row.inspectionList3Cd,
                  prbno: row.defectiveNo,
                })
                if (res && res?.list?.length) {
                  let yyItem = res.list[0]
                  row.taiyy = yyItem?.taiyy
                  row.taiym = yyItem?.taiym
                }
              }
              this.$forceUpdate()
            }
          }
        })
        return list
      },
      // 総合設備点検不具合No
      async getMprbnop(row) {
        const res = await mprbnoFoundData({
          inlstbr1cd: row.inspectionList1Cd,
          inlstbr2cd: row.inspectionList2Cd,
          inlstbr3cd: row.inspectionList3Cd,
          prbno: row.defectiveNo,
        })
        if (res && res?.list?.length) {
          let item = res.list[0]
          row.taiyy = item?.taiyy
          row.taiym = item?.taiym
        }
      },
      // 開始時刻を取得する
      async getCreateDate(item) {
        if (item.equipmentInspectionModelList.length > 0) {
          let equipmentItem = item.equipmentInspectionModelList[0]
          equipmentItem.usestrym = ''
          if (
            equipmentItem.inspectionList1Cd == '01' &&
            equipmentItem.inspectionList2Cd == '01' &&
            equipmentItem.machineNo &&
            item.workNo
          ) {
            const list = await getCreateDate({
              blgscd: this.currentBascInfo.buildingCd, // 建物ＣＤ
              bldgcd: item.reportSectionCd, // 棟ＣＤ
              nb: equipmentItem?.machineNo, // 号機
            })
            if (list && list.length == 0) {
              equipmentItem.usestrym = ''
            } else {
              let useRow = list[0]
              for (let index = 0; index < list.length; index++) {
                const use = list[index]
                if (this.$baseLodash.isObject(use)) {
                  useRow = use
                  break
                }
              }
              if (!useRow?.usestrym) {
                equipmentItem.usestrym = ''
              } else {
                this.useTimeformat(useRow, item, equipmentItem)
              }
            }
          } else {
            equipmentItem.usestrym = ''
          }
        }
      },
      blurNoInput(item) {
        this.getCreateDate(item)
      },
      // 経過年数
      useTimeformat(useRow, item, equipmentItem) {
        let endYear = parseInt(
          this.$dayjs().format('YYYY').toString().substring(0, 2) +
            '' +
            item.workNo.substring(0, 2)
        )
        let endMonth = parseInt(item.workNo.substring(2, 4))
        let startYear = parseInt(
          this.$dayjs(useRow.usestrym.toString()).format('YYYY')
        )
        let startMonth = parseInt(
          this.$dayjs(useRow.usestrym.toString()).format('MM')
        )

        let monthJ1 = false
        let yearJ1 = false
        // let mDay = endDay - startDay
        let mMonth = endMonth - startMonth
        let mYear = endYear - startYear
        if (monthJ1) {
          mMonth = mMonth - 1
        }
        if (mMonth < 0) {
          yearJ1 = true
          mMonth = mMonth + 12
        }
        if (mYear > 0) {
          if (yearJ1) {
            mYear = mYear - 1
          }
        }
        let formatText =
          mYear +
          '年' +
          mMonth +
          'ヶ月' +
          '（開始年月：' +
          useRow.usestrym +
          '〜' +
          // useRow.useendym +
          ' ）'
        equipmentItem.usestrym = formatText
      },
      clearEquipmentInspectionItem(item) {
        item.reportContent = null
        item.defectiveNo = null
        item.inspectionItemsNo = null
        item.usestrym = null
        item.taiyy = null
        item.taiym = null
      },
      // 根拠 総設分類3 取得する  分類3名
      inspectionList3CdChange(item, parent) {
        let data3 = item.inspectionList3CdList.filter((son) => {
          return item.inspectionList3Cd == son.inlstbr3cd
        })
        item.br3nm = data3[0].br3nm
        this.clearEquipmentInspectionItem(item)
        this.getCreateDate(parent)
      },
      // 根拠 総設分類2 取得する 総設分類3
      async inspectionList2CdChange(item, parent) {
        item.inspectionList3Cd = null
        item.inspectionList3CdList = []
        item.br3nm = null
        item.inspectionList3CdList = this.inspectionList3CdList.filter(
          (son) =>
            son.inlstbr1cd == item.inspectionList1Cd &&
            son.inlstbr2cd == item.inspectionList2Cd
        )

        let data2 = item.inspectionList2CdList.filter((son) => {
          return item.inspectionList2Cd == son.inlstbr2cd
        })
        item.br2nm = data2[0].br2nm
        this.clearEquipmentInspectionItem(item)
        this.getCreateDate(parent)
      },
      // 根拠 総設分類1 取得する 総設分類2
      async inspectionList1CdChange(item, parent) {
        item.inspectionList2Cd = null
        item.inspectionList3Cd = null
        item.inspectionList3CdList = []
        item.inspectionList2CdList = []
        item.br1nm = null
        item.br2nm = null
        item.br3nm = null
        item.inspectionList2CdList = this.inspectionList2CdList.filter(
          (son) => son.inlstbr1cd == item.inspectionList1Cd
        )
        let data1 = item.inspectionList1CdList.filter((son) => {
          return item.inspectionList1Cd == son.inlstbr1cd
        })
        item.br1nm = data1[0].br1nm
        this.clearEquipmentInspectionItem(item)
        this.getCreateDate(parent)
      },
      // 総設分類1
      async getInspectionList1CdList1() {
        const res = await getComprehensiveClassification1({})
        if (res) {
          this.inspectionList1CdList = res.list ?? []
        }
      },
      // 総設分類2
      async getInspectionList1CdList2() {
        const res = await getComprehensiveClassification2({})
        if (res) {
          this.inspectionList2CdList = res.list ?? []
        }
      },
      // 総設分類3
      async getInspectionList1CdList3() {
        const res = await getComprehensiveClassification3({})
        if (res) {
          this.inspectionList3CdList = res.list ?? []
        }
      },
      // 不具合Noフォーマット化します
      defectNoFormat(defectNo) {
        if (defectNo) {
          return defectNo.substring(0, 2) + '-' + defectNo.substring(2, 3)
        } else {
          return null
        }
      },
      // 作業報告を追加
      getEquipmentItem(item) {
        return {
          reportDetailId: item?.reportDetailId,
          operationType: this.$divisions.operationTypeEnum.enum_U.value,
          defectPhotoModelList: [],
          photoReceiveFlag:
            this.$divisions.photoReceiveFlagEnum.enum_blank.value,
          equipmentInspectionId: null,
          reportContent: null,
          previousReportContent: null,
          reportDealContent: null,
          reportComment: null,
          defectiveNo: null,
          inspectionList1Cd: null,
          inspectionList2Cd: null,
          inspectionList3Cd: null,
          inspectionList1CdList: this.inspectionList1CdList,
          inspectionList2CdList: [],
          inspectionList3CdList: [],
          afteryears: null,
          br1nm: null,
          br2nm: null,
          br3nm: null,
          inspectionItemsNo: null,
          machineNo: null,
          position: null,
          meterValue: null,
          previousValue: null,
          usestrym: null,
          useendym: null,
          taiyy: null,
          workNo: null,
          reportNo: null,
          buildingCd: this.currentBascInfo?.buildingCd,
        }
      },
      // 作業報告を追加
      addWorkNoReportList() {
        if (this.isEquipment) {
          this.form.reportDetailRcModelList.push({
            workFold: true,
            workNo: null,
            reportSectionCd: null,
            blgsnmkj: null,
            responseStatus: this.$divisions.responseStatusEnum.enum_1.value,
            equipmentInspectionModelList: [
              {
                reportDetailId: null,
                operationType: this.$divisions.operationTypeEnum.enum_I.value,
                defectPhotoModelList: [],
                photoReceiveFlag:
                  this.$divisions.photoReceiveFlagEnum.enum_blank.value,
                equipmentInspectionId: null,

                reportContent: null,
                previousReportContent: null,
                reportDealContent: null,
                reportComment: null,
                defectiveNo: null,
                inspectionList1Cd: null,
                inspectionList2Cd: null,
                inspectionList3Cd: null,
                inspectionList1CdList: this.inspectionList1CdList,
                inspectionList2CdList: [],
                inspectionList3CdList: [],
                afteryears: null,
                br1nm: null,
                br2nm: null,
                br3nm: null,
                inspectionItemsNo: null,
                machineNo: null,
                position: null,
                meterValue: null,
                previousValue: null,
                usestrym: null,
                useendym: null,
                taiyy: null,
                workNo: null,
                reportNo: null,
                buildingCd: null,
              },
            ],
          })
        } else {
          this.form.reportDetailRcModelList.push({
            workFold: true,
            workNo: null,
            reportSectionCd: null,
            responseStatus: this.$divisions.responseStatusEnum.enum_1.value,
            blgsnmkj: null,
          })
        }
        this.$nextTick(() => {
          let index = this.form.reportDetailRcModelList.length - 1
          this.$refs['workReportRef' + index][0].setValue(
            this.$divisions.responseStatusEnum.enum_1.value
          )
        })
      },
      // 不具合情報
      async getDefectReportsList() {
        let list = await getDefectReport(this.getReportRequestData())
        if (list && list.length == 0) {
          list =
            this.preBasicInfo?.reportNo &&
            (await getDefectReport({
              reportNo: this.preBasicInfo?.reportNo,
              currentReportNoFlg: false,
            }))
        }
        this.form.defectReportModelList = []
        if (list?.length) {
          list.forEach((item, index) => {
            if (this.currentBascInfo) {
              item.buildingCd = this.currentBascInfo?.buildingCd
            }
            setTimeout(() => {
              if (this.$refs['defectRadioRef' + index]) {
                this.$refs['defectRadioRef' + index][0].setValue(
                  item.inspectionStatus
                )
              }
            }, 0)
            if (this.$baseLodash.isNull(item.defectReportId)) {
              item.operationType =
                this.$divisions.operationTypeEnum.enum_I.value
            } else {
              item.operationType =
                this.$divisions.operationTypeEnum.enum_U.value
            }
          })
          this.form.defectReportModelList = list
          this.clone.defectReportModelList = this.$baseLodash.cloneDeep(list)
        }
      },
      // 不具合情報Add
      addDefectReportList() {
        this.form.defectReportModelList.push({
          defectId: null,
          buildingCd: this.currentBascInfo?.buildingCd,
          operationType: this.$divisions.operationTypeEnum.enum_I.value,
          defectIdModel: {
            location: null,
            defectContent: null,
            defectPhotoModelList: [],
          },
          inspectionStatus: this.$divisions.inspectionStatusEnum.enum_3.value,
        })
        this.$nextTick(() => {
          this.$refs[
            'defectRadioRef' + (this.form.defectReportModelList.length - 1)
          ][0].setValue(this.$divisions.inspectionStatusEnum.enum_3.value)
        })
      },
      deleteReportDetailRc(item, index) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'ok',
          yes: () => {
            this.form.reportDetailRcModelList.splice(index, 1)
          },
        })
      },
      // 不具合削除
      deleteDefectReportList(item, index) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'ok',
          yes: () => {
            if (item.defectId) {
              this.form.defectReportModelList[index].operationType =
                this.$divisions.operationTypeEnum.enum_D.value
            } else {
              this.form.defectReportModelList.splice(index, 1)
            }
          },
        })
      },
      // 不具合情報idget
      async getDefectIdBeforeUpload(item, index) {
        this.$refs['defectUploadRef' + index][0].uploadFile()
      },
      // 作業実施情報
      async getWorkImplementLists() {
        if (this.reportId) {
          const res = await getworkImplementInfoList(this.reportId)
          if (res.length) {
            let list = res.filter((item) => item.reportSectionCd != '  ')
            list.filter((item) => {
              item.roomList = this.roomListbox.filter(
                (room) => room.bldgcd == item.reportSectionCd
              )
            })
            this.form.workImplementInfoModelList = list
            this.form.workImplementInfoModelList.filter((item, index) => {
              if (this.checkEnumFlag(item.allImplementClass)) {
                this.$nextTick(() => {
                  this.$refs['allFlagRef' + index][0].setValue(
                    item.allImplementClass
                  )
                })
              }
            })
            this.clone.workImplementInfoModelList =
              this.$baseLodash.cloneDeep(list)
            // 全戸数 実施率の初期化
            this.createWorkUnimplementsRate()
            //  全戸数 実施率 計算
            this.handleWorkUnimplementChange()
          }
          if (this.form.workImplementInfoModelList.length == 0) {
            this.createWorkimplements()
          }
        } else {
          this.createWorkimplements()
        }
      },
      // 作業実施情報の初期化
      async createWorkimplements() {
        if (
          !this.currentBascInfo.sectionCd ||
          !this.currentBascInfo.sectionCd.trim()
        ) {
          // 報告書建建物ＣＤ棟
          for (let i = 0; i < this.mbuildList.length; i++) {
            if (this.mbuildList[i].bldgcd != '  ') {
              let roomList = this.roomListbox.filter(
                (room) => room.bldgcd == this.mbuildList[i].bldgcd
              )
              this.form.workImplementInfoModelList.push({
                allImplementClass:
                  this.$divisions.boolFlagEnum.enum_blank.value,
                reportSectionCd: this.mbuildList[i].bldgcd, //棟
                blgsnmkj: this.mbuildList[i].blgsnmkj, // 建物名称漢字
                roomList: roomList,
                buildingCd: this.mbuildList[i].blgscd,
                operationType: this.$divisions.operationTypeEnum.enum_I.value,
                workUnimplementInfoModelList: [], // 作業未実施区画情報モデルリスト
              })
            }
          }
        } else {
          // 報告書棟
          let roomList = this.roomListbox.filter(
            (room) => room.bldgcd == this.currentBascInfo.sectionCd
          )
          roomList.filter((item) => {
            item.disabled = false
          })
          this.form.workImplementInfoModelList.push({
            allImplementClass: this.$divisions.boolFlagEnum.enum_blank.value,
            reportSectionCd: this.currentBascInfo.sectionCd, //棟
            blgsnmkj: this.getFieldValue(
              'buildingCdMbuildgpModel.blgsnmkj',
              this.currentBascInfo
            ), // 建物名称漢字
            roomList: roomList,
            reportId: this.reportId,
            buildingCd: this.currentBascInfo.buildingCd,
            operationType: this.$divisions.operationTypeEnum.enum_I.value,
            workUnimplementInfoModelList: [], // 作業未実施区画情報モデルリスト
          })
        }
        // 全戸数 実施率の初期化
        this.createWorkUnimplementsRate()
        //  全戸数 実施率 計算
        this.handleWorkUnimplementChange()
      },
      // 作業未実施住戸追加
      async addWorkUnimplementList(item, index) {
        let parent = this.form.workImplementInfoModelList[index]
        this.form.workImplementInfoModelList[
          index
        ].workUnimplementInfoModelList.push({
          roomNo: null, // ＲＯＯＭＮＯ
          unimplementClass: null, // 未実施区分
          comment: null, // コメント
          reportId: this.reportId,
          buildingCd: parent.buildingCd,
          reportSectionCd: parent?.reportSectionCd,
          workImplementId: parent?.workImplementId,
          operationType: this.$divisions.operationTypeEnum.enum_I.value,
        })
      },
      // 全戸数 実施率の初期化
      createWorkUnimplementsRate() {
        // 全戸数
        this.form.inspectionTargetRoomNum = 0
        this.form.workImplementInfoModelList.forEach((item) => {
          this.form.inspectionTargetRoomNum += item.roomList.length
        })
      },
      // コメント
      changeInput(item, index) {
        if (this.$baseLodash.isUndefined(index)) return
        let parent = this.form.workImplementInfoModelList[index]
        if (parent && !parent?.operationType) {
          parent.operationType = this.$divisions.operationTypeEnum.enum_U.value
        }
        if (item && !item?.operationType) {
          item.operationType = this.$divisions.operationTypeEnum.enum_U.value
        }
      },
      // 全戸数 実施率 計算
      handleWorkUnimplementChange(item, index) {
        this.changeInput(item, index)
        // 未実施戸数
        this.form.uncheckRoomNum = 0
        let unList = this.form.workImplementInfoModelList.filter(
          (item) =>
            item.allImplementClass ==
            this.$divisions.boolFlagEnum.enum_blank.value
        )
        unList.filter((item) => {
          let sonUnList = item.workUnimplementInfoModelList.filter(
            (son) => son.roomNo && son.unimplementClass
          )
          this.form.uncheckRoomNum += sonUnList.length
        })
        //実施率 =  ((点検対象戸数 - 未実施戸数計) / 点検対象戸数)
        if (this.form.inspectionTargetRoomNum) {
          this.form.checkRate = (
            ((this.form.inspectionTargetRoomNum - this.form.uncheckRoomNum) /
              this.form.inspectionTargetRoomNum) *
            100
          ).toFixed(1)
        } else {
          this.form.checkRate = (0).toFixed(1)
        }
      },
      // 全戸実施 checkbox
      isAllWorkImplementChange(item, index) {
        // 全戸数 実施率の初期化
        this.createWorkUnimplementsRate()
        //  全戸数 実施率 計算
        this.handleWorkUnimplementChange(item, index)
      },
      // 棟内区画
      async getBuildingPartitions() {
        const res = await getBuildingPartition({
          blgscd: this.currentBascInfo?.buildingCd,
        })
        if (res.list && res.list.length) {
          this.roomListbox = res.list
        }
      },
      // 総合設備点削除します
      deleteEquipmentResultList(index, item) {
        if (item.equipmentInspectionId) {
          this.form.reportDetailRcModelList[
            index
          ].equipmentInspectionModelList.filter((row) => {
            row.operationType = this.$divisions.operationTypeEnum.enum_D
          })
        }
        this.form.reportDetailRcModelList.splice(index, 1)
      },
      criterionShow(row, actionRow) {
        let reportYear = this.$route.query.workNo.substring(0, 2)
        let reportMonth = this.$route.query.workNo.substring(2, 4)
        if (
          this.$baseLodash.isEmpty(actionRow.usestrym) ||
          this.$baseLodash.isEmpty(row[0].taiyy)
        ) {
          let rows = row[0]
          let text = ''
          if (rows?.prtwrd1) {
            text += rows?.prtwrd1?.trim()
          }
          if (rows?.prtwrd2) {
            text += rows?.prtwrd2?.trim()
          }
          if (rows?.prtwrd3) {
            text += rows?.prtwrd3?.trim()
          }
          if (rows?.prtwrd4) {
            text += rows?.prtwrd4?.trim()
          }
          if (rows?.prtwrd5) {
            text += rows?.prtwrd5?.trim()
          }
          return text
        }
        let createym = this.$dayjs(actionRow.usestrym.toString(), 'YYYYMM')
        let createYear = this.$dayjs(createym).format('YY')
        let createMonth = this.$dayjs(createym).format('MM')
        let useYear = reportYear - createYear
        let useMonth = reportMonth - createMonth
        let useYm = useYear + '' + useMonth
        let taiYm = row[0].taiyy + '' + row[0].taiym
        //「経過年数」＜「耐用年数」の場合、不具合NOマスタの「出力文言(1～5）」を報告内容にセット、
        if (useYm < taiYm) {
          let rows = row[0]
          let text = ''
          if (rows?.prtwrd1) {
            text += rows?.prtwrd1?.trim()
          }
          if (rows?.prtwrd2) {
            text += rows?.prtwrd2?.trim()
          }
          if (rows?.prtwrd3) {
            text += rows?.prtwrd3?.trim()
          }
          if (rows?.prtwrd4) {
            text += rows?.prtwrd4?.trim()
          }
          if (rows?.prtwrd5) {
            text += rows?.prtwrd5?.trim()
          }
          return text
        }
        //「経過年数」≧「耐用年数」の場合、不具合NOマスタの「出力文言（超過）(1～5）」を報告内容にセット
        if (useYm >= taiYm) {
          let rows = row[0]
          let text = ''
          if (rows?.prtwrdovr1) {
            text += rows?.prtwrdovr1?.trim()
          }
          if (rows?.prtwrdovr2) {
            text += rows?.prtwrdovr2?.trim()
          }
          if (rows?.prtwrdovr3) {
            text += rows?.prtwrdovr3?.trim()
          }
          if (rows?.prtwrdovr4) {
            text += rows?.prtwrdovr4?.trim()
          }
          if (rows?.prtwrdovr5) {
            text += rows?.prtwrdovr5?.trim()
          }

          return text
        }
      },
      // 不具合No選択
      handledefectNoChose(row, index, actionRow, sonIndex) {
        this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
          sonIndex
        ].reportContent = this.criterionShow(row, actionRow)
        this.form.reportDetailRcModelList[index].reportContent =
          this.criterionShow(row, actionRow)

        this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
          sonIndex
        ].taiyy = row[0]?.taiyy
        this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
          sonIndex
        ].taiym = row[0]?.taiym
        this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
          sonIndex
        ].defectiveNo = row[0]?.prbno
        this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
          sonIndex
        ].inspectionItemsNo = row[0]?.initemno
        this.novisable = false
        this.$forceUpdate()
      },
      // 写真アップロード禁止です
      uploadDisabled() {
        return false
      },
      // アップロード成功です
      successPhotoFile(file, index, equiIndex) {
        if (this.isEquipment) {
          let model =
            this.form.reportDetailRcModelList[index]
              .equipmentInspectionModelList[equiIndex]
          if (model && !file.equipmentInspectionId) {
            file.equipmentInspectionId = model.equipmentInspectionId
          }
          this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
            equiIndex
          ].defectPhotoModelList.push(file)
        } else {
          let model = this.form.defectReportModelList[index].defectIdModel
          if (model && !file.defectId) {
            file.defectId = model.defectId
          }
          this.form.defectReportModelList[
            index
          ].defectIdModel.defectPhotoModelList.push(file)
        }
      },
      // ダウンロード写真
      async defectPhotoDownLoad(row, file) {
        this.downloadCommon.resource(
          `/api/defectPhoto/download`,
          { ...file, reportNo: this.reportNo },
          null
          // `${this.$const.worksApiPre}`
        )
      },
      //  不具合写真 删除
      async deleteFile(file, item, index) {
        let res = await defectPhotoDelete({ ...file, reportNo: this.reportNo })
        if (res) {
          this.msgSuccess(
            this.$t(`validateMessage.${this.$messageCode.I00000414.name}`)
          )
          item.defectIdModel.defectPhotoModelList.splice(index, 1)
          item.defectIdModel.defectPhotoModelList.push(res)
        }
      },
      // 不具合写真 删除
      handleDefectPhotoDelete(file, item, f) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'ok',
          yes: () => {
            this.deleteFile(file, item, f)
          },
        })
      },
      // 総合設備点検不具合写真 删除
      handleEqumentDefectPhotoDelete(file, item, index, sonIndex, f) {
        this.$confirm({
          msg: this.$t(`validateMessage.${this.$messageCode.I00000412.name}`),
          yesText: 'ok',
          yes: () => {
            this.deleteFileEqument(file, item, index, sonIndex, f)
          },
        })
      },
      //  不具合写真 削除します
      async deleteFileEqument(file, item, index, sonIndex, f) {
        let res = await defectPhotoDelete({ ...file, reportNo: this.reportNo })
        if (res) {
          this.msgSuccess(
            this.$t(`validateMessage.${this.$messageCode.I00000414.name}`)
          )
          this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
            sonIndex
          ].defectPhotoModelList.splice(f, 1)
          this.form.reportDetailRcModelList[index].equipmentInspectionModelList[
            sonIndex
          ].defectPhotoModelList.push(res)
        }
      },
      // 不具合履歴
      withoutExperienceDialog(defectId) {
        this.$refs.errorRecords.getData(defectId, this.reportNo)
      },
      // 別紙_点検総括表_2
      async excelDown() {
        // try {
        //   let res = null
        //   this.$baseColorfullLoading()
        //   if (this.isEquipment) {
        //     res = await getEquipmentInspectionFile1({
        //       reportNo: this.$route.query.workNo,
        //     })
        //   } else {
        //     res = await getDefectReportFile({
        //       reportNo: this.$route.query.workNo,
        //     })
        //   }

        //   if (res) {
        //     this.downloadBlob(res.data, res.filename)
        //     this.msgSuccess(
        //       this.format(
        //         this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
        //         '出力'
        //       )
        //     )
        //   }
        // } finally {
        //   this.$baseColorfullLoading().close()
        // }
        if (this.isEquipment) {
          this.downloadCommon.resource(
            '/api/equipmentInspection/exportInspection1',
            {
              reportNo: this.$route.query.workNo,
            }
          )
        } else {
          this.downloadCommon.resource('/api/defectReport/exportInspection2', {
            reportNo: this.$route.query.workNo,
          })
        }
      },
      // 作業報告 対応状況 登録完了（不具合なし）
      responseStatusFilter(item, index) {
        if (
          this.isEqualCodeEnum(
            item.responseStatus,
            this.$divisions.responseStatusEnum.enum_3
          )
        ) {
          this.form.reportDetailRcModelList[index].reportContent = null
          this.form.reportDetailRcModelList[index].reportDealContent = null
          this.form.reportDetailRcModelList[index].reportComment = null
        }
      },
      // データを整理します
      getSubmitData() {
        let data = {
          ...this.form,
        }
        if (this.reportId) {
          data = { ...this.reportBaseInfo, ...data }
        }
        if (this.setDefFormData) {
          data = {
            ...data,
            reportFormat: this.reportFormat,
            defectFlag: this.setDefFormData.defectFlag,
            officalConfrimClass: this.setDefFormData.officalConfrimClass,
            patternId: this.setDefFormData.patternId,
          }
        }
        data = {
          ...data,
          reportNo: this.reportNo,
          buildingCd: this.currentBascInfo.buildingCd,
          lastReportId: this.preBasicInfo?.reportIdModel?.reportId,
          reportFileRcModelList: [],
          reportDetailRcModelList: [],
          defectReportModelList: this.$baseLodash.cloneDeep(
            this.form.defectReportModelList
          ),
        }
        // 報告書ファイルRCモデルリスト
        this.reportFileRcModelList.filter((item) => {
          data.reportFileRcModelList.push(...item.list[0].fileList)
        })
        // 報告書詳細RCモデルリスト
        data.reportDetailRcModelList = this.compareArr({
          originArr: this.clone.reportDetailRcModelList,
          targetArr: this.form.reportDetailRcModelList,
          identifyKey: 'reportDetailId',
          keys: [
            'reportContent', // 報告書内容
            'responseStatus', // 対応状況
            'reportDealContent', // 対処内容
            'reportComment', // 報告書コメント
            'workNo', // 作業No
            'reportSectionCd', // 報告書棟ＣＤ
            'equipmentInspectionModelList', // 総合設備点検モデルリスト
          ],
        })
        // 不具合報告モデルリスト
        // data.defectReportModelList = this.compareArr({
        //   originArr: this.clone.defectReportModelList,
        //   targetArr: this.form.defectReportModelList,
        //   identifyKey: 'defectReportId',
        //   keys: [
        //     'inspectionStatus', // 点検結果
        //     'defectIdModel.location', // 場所
        //     'defectIdModel.defectContent', // 不具合内容
        //     'defectIdModel.defectPhotoModelList', // 不具合写真
        //   ],
        // })
        // 作業実施情報モデルリスト
        data.workImplementInfoModelList = this.$baseLodash.cloneDeep(
          this.form.workImplementInfoModelList
        )
        // data.workImplementInfoModelList = this.compareArr({
        //   originArr: this.clone.workImplementInfoModelList,
        //   targetArr: this.form.workImplementInfoModelList,
        //   identifyKey: 'workImplementId',
        //   keys: [
        //     'reportSectionCd', // 報告書棟ＣＤ
        //     'allImplementClass', // 全戸実施区分
        //     'workUnimplementInfoModelList.roomNo', // ＲＯＯＭＮＯ
        //     'workUnimplementInfoModelList.comment', // コメント
        //     'workUnimplementInfoModelList.unimplementClass', // 未実施区分
        //   ],
        // })
        data.workImplementInfoModelList.filter((item) => {
          delete item['roomList']
          delete item['chooseList']
          if (
            item.workUnimplementInfoModelList &&
            item.workUnimplementInfoModelList.length > 0
          ) {
            let list = []
            item.workUnimplementInfoModelList.filter((row) => {
              if (
                this.isEqualCodeEnum(
                  row.operationType,
                  this.$divisions.operationTypeEnum.enum_I
                )
              ) {
                if (
                  (!this.$baseLodash.isEmpty(row.roomno) &&
                    !this.$baseLodash.isNull(row.roomno)) ||
                  (!this.$baseLodash.isEmpty(row.unimplementClass) &&
                    !this.$baseLodash.isNull(row.unimplementClass))
                ) {
                  list.push(row)
                }
              } else {
                list.push(row)
              }
            })
            item.workUnimplementInfoModelList = list
          }
        })
        data.reportDetailRcModelList.filter((row) => {
          row.buildingCd = this.currentBascInfo.buildingCd
          row.equipmentInspectionModelList &&
            row.equipmentInspectionModelList.filter((item) => {
              delete item['inspectionList1CdList']
              delete item['inspectionList2CdList']
              delete item['inspectionList3CdList']
              item.buildingCd = this.currentBascInfo.buildingCd
              item.reportSectionCd = row.reportSectionCd
            })
        })
        // 正式版報告書状況 officalReportStatus  速報版報告書状況 preReportStatus
        // this.setReportStatus(data)
        if (this.btnData?.key) {
          data[this.btnData.key] = this.btnData.value
        }

        return data
      },
      // 更新
      async submitForm() {
        const loadingInstance = this.$baseColorfullLoading()
        try {
          const res = await insOrUpd(this.getSubmitData())
          if (!res) {
            this.msgSuccess(
              this.format(
                this.$t(`validateMessage.${this.$messageCode.I00000266.name}`),
                '更新'
              )
            )
            this.$closePage(this.$route.path)
            this.$routerPushAndReload({
              path: '/report/PWR02G05',
              refresh: 'PWR02G05',
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
<style lang="scss" scoped>
  .width160 {
    width: 160px;
  }
  .wid80 {
    width: 80px;
  }

  .build_section {
    display: flex;
    align-items: center;
    .build_section_item {
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      color: #000000;
    }
    .build_section_item:last-child {
      margin-left: 15px;
    }
  }
  .fault_no_btn_disabled {
    background: #ffffff !important;
    border: 1px solid #a1a1a1 !important;
    color: #a1a1a1 !important;
    cursor: no-drop !important;
    &:hover {
      border: 1px solid #a1a1a1 !important;
      color: #a1a1a1 !important;
    }
    .svg-icon {
      color: #a1a1a1 !important;
    }
  }
  .arrow_svg_right {
    font-size: 18px;
  }
</style>
